<!-- User Upload Check & Trigger Save -->

<template>
	<div class="upload-check-main">
		
		<div class="title">
			Upload Checklist
		</div>

		<div v-for="(item, key) in status" :key="'chk' + key">
			<div class="detail-line">
				<div class="detail-label">{{ item.title }}:</div>
				<div class="detail-icon">
					<UniIcon 
						:ico="item.ico" 
						:color="item.color" 
						fit="1"
					/>
				</div>
				<div class="detail-descr">{{ item.mess }}</div>
			</div>
			<div class="separator"></div>
		</div>


		<div class="detail-line">
			<div class="post-box">
				<div class="post-btn" @click="showTOS"> 
					<UniIcon 
						ico="ribbon" 
						color="#369" 
						fit="1"
					/>
				</div>
			</div>
			<div class="post-txt">Click to read the Terms of Service</div>
		</div>

		<div class="detail-line">
			<div class="post-box">
				<div class="chk-box" @click="toggleAgree">
					<UniIcon v-if="agree"
						ico="check" 
						color="#090" 
						fit="1"
					/>
				</div>
			</div>
			<div class="post-txt">Yes, I agree with Terms of Service</div>
		</div>

		<div class="detail-line" v-if="allOK">
			<div class="post-box">
				<div class="post-btn wi8_font" @click="goPost" v-if="agree"> 
					Post!
				</div>
				<div class="post-btn disabled wi8_font" v-else> 
					Post!
				</div>
			</div>
			<div class="post-txt">Click to post!</div>
		</div>

		<div class="detail-line" v-else>
			<div class="post-box">
				<div class="post-btn disabled wi8_font"> 
					Post!
				</div>
			</div>
			<div class="post-txt err">
				<div class="detail-icon">
					<UniIcon 
						ico="notice" 
						color="#C30" 
						fit="1"
					/>
				</div>
				<span style="position: relative; top: 4px;">Fix issues before Posting</span>
			</div>
		</div>

	</div>
</template>

<script>
import * as Utils from "@/utils/utils"
import { m } from "@/utils/utils.js";
import { mapState } from "vuex";
import { eventBus } from "@/main";
const step = "upload";

export default {
	data() {
		return {
			status: {
				cat:	{title: "Category"	,ok: true	,ico: "check"	,color: "#090"	,mess: ""},
				title:	{title: "Title"		,ok: true	,ico: "check"	,color: "#090"	,mess: ""},
				story:	{title: "Story"		,ok: true	,ico: "check"	,color: "#090"	,mess: ""},
				pix:	{title: "Images"	,ok: true	,ico: "check"	,color: "#090"	,mess: ""},
			},
			allOK: false,
			agree: false,
		}
	},
	computed: {
		...mapState({art: state => state.app.upload.art}),
		...mapState({pix: state => state.app.upload.pix}),
	},
	methods: {
		goPost() {
			m("go post");
			Utils.blur();

			let payloadPost = {
				popType: "win",
				popTitle: "Posting Article",
				popText: "",
				compName: "UniPost",
				compData: {
					step: "upload",
					autoPost: true,
				},
			};

			let payloadTrx = {
				trx:"clear",
			}

			// Clear trx status then post
			this.$store.dispatch("app/updTrxStatus", payloadTrx)
			.then( () => {
				eventBus.$emit("popup", payloadPost);	
			})


		},
		toggleAgree() {
			m("toggleAgree");
			Utils.blur();
			this.agree = !this.agree;
		},
		showTOS() {
			m("show tos");
			Utils.blur();
			let payload = {
				popType: "win",
				popTitle: "Terms of Service",
				popText: "",
				compName: "TosMess",
				compData: {
					text: "",
				},
			};
			eventBus.$emit("popup", payload);			
		},
		calcAllOK() {
			m("calc all OK");
			this.allOK = this.status.title.ok && this.status.story.ok;
		},
		calcStatusCat() {
			m("calc status cat");

			if (this.art.cat.itemId!=="all") {
				this.status.cat.mess = this.art.cat.title;
			} else {
				this.status.cat.ok = false;
				this.status.cat.ico = "notice_yellow";
				this.status.cat.color = "#C30";
				this.status.cat.mess = "Wait! You can pick a category (optional)"
			}


		},
		calcStatusTitle() {
			m("calc status title");
			if (this.art.title.length>0) {
				this.status.title.mess = "Title has " + this.art.title.length + " characters";
			} else {
				this.status.title.ok = false;
				this.status.title.ico = "notice";
				this.status.title.color = "#C30";
				this.status.title.mess = "Oops! Please enter a title."
			}
		},
		calcStatusStory() {
			m("calc status story");
			if (this.art.fullTxt.length>0) {
				this.status.story.mess = "Story has " + this.art.fullTxt.length + " characters";
			} else {
				this.status.story.ok = false;
				this.status.story.ico = "notice";
				this.status.story.color = "#C30";
				this.status.story.mess = "Oops! Please write your story."
			}
		},
		calcStatusPix() {
			m("calc status pix");
			if (this.pix.length>0) {
				this.status.pix.mess = this.pix.length + " images uploaded (optional)";
			} else {
				this.status.pix.ok = false;
				this.status.pix.ico = "notice_yellow";
				this.status.pix.color = "#C30";
				this.status.pix.mess = "Wait! You can add images (optional)";
			}
		},
	},
	mounted() {
		this.calcStatusCat();
		this.calcStatusTitle();
		this.calcStatusStory();
		this.calcStatusPix();
		this.calcAllOK();
	},

}
</script>

<style scoped>

.upload-check-main {
	height: 100%;
	overflow: hidden;
	padding: 20px;
	border: solid 0px #C30;
}

.title {
	height: 30px;
	overflow: hidden;
	color: #369;
	font-weight: bold;
	border: solid 0px #369;
}

.detail-line {
	height: 50px;
	overflow: hidden;
	padding: 5px 0px 0px 0px;
	border: solid 0px #C30;
}

.detail-label {
	display: inline-block;
	width: 70px;
	height: 30px;
	overflow: hidden;
	vertical-align: top;
	padding: 4px 0px 0px 0px;
	border: solid 0px #C30;
}

.detail-icon {
	display: inline-block;
	width: 30px;
	height: 25px;
	overflow: hidden;
	vertical-align: top;
	border: solid 0px #000;
}

.detail-descr {
	display: inline-block;
	width: 200px;
	height: 40px;
	overflow: hidden;
	vertical-align: top;
	padding: 4px 0px 0px 10px;
	border: solid 0px #090;
}

.separator {
	height: 5px;
	overflow: hidden;
	border-bottom: solid 1px #999;	
}

.post-txt {
	float: right;
	width: 220px;
	height: 35px;
	overflow: hidden;
	text-align: right;
	padding: 5px 20px 0px 0px;
	border: solid 0px #090;
}

.err {
	color: #C30;
	font-weight: bold;
	background-color: #FEE;
	padding: 0px 20px 0px 0px;
	border-radius: 5px;
	border: solid 2px #C30;
}

.post-box {
	float:right;
	width: 80px;
	height: 35px;
	overflow: hidden;
	vertical-align: top;
	/* cursor: pointer; */
	padding: 0px 0px 0px 10px;
	border: solid 0px #C30;
}

.post-btn {
	width: 60px;
	height: 33px;
	overflow: hidden;
	cursor: pointer;
	background-color: #FFF;
	color: #369;
	font-size: 16px;
	padding: 2px 0px 0px 5px;
	border-radius: 4px;
	border: solid 2px #369;

}

.disabled {
	color: #999;	
	cursor:default;
	background-color: #EEE;
	border-color: #999;
}

.chk-box {
	width: 33px;
	height: 33px;
	overflow: hidden;
	cursor: pointer;
	background-color: #FFF;
	border-radius: 4px;
	border: solid 1px #999;	
}

</style>
